import StringUtility from 'utils/stringReplacement';

const copy = new StringUtility({
  description: `In order to provide the Services, FanAI uses products and services from the following companies, each a "Subprocessor" under GDPR:`,
  experian: `Experian`,
  firstData: `First Data`,
  header: `List of Subprocessors`,
  masterCard: `MasterCard`,
  title: `FanAI's compliance with GDPR`,
  zipCodes: `zip-codes.com`,
});

export default copy;
